// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"7a50530b","551":"b5d6697f","842":"9f986dfc"}[chunkId] + ".chunk.js";
};